import './polyfill'
import init from './init'
import Vue from 'vue'
import router from './init/router'
import App from './App'
import store from 'store'
import i18n from 'src/i18n'
import nProgress from 'nprogress'
nProgress.set(0.7)
init().finally(() => {
  const instance = new Vue({
    name: 'Root',
    router,
    store,
    i18n,
    render: h => h(App),
    watch: {
      language(lang) {
        Vue.$showBrowserTips()
        this.$i18n.locale = lang
      }
    },
    mounted() {
      nProgress.done()
      Vue.$showBrowserTips()
    },
    computed: {
      language() {
        return this.$store.state.settings.language
      }
    }
  })
  instance.$mount('#app')
  window.Vue = Vue
  window.app = instance
})
